export default {"src":"/_next/static/media/talent.543d2cb0.svg","height":51,"width":52,"blurWidth":0,"blurHeight":0};